module.exports = __webpack_public_path__ + "files/4f2b0bb35274f067842595fc105da3a4.png";